import React, { useState, useEffect } from "react";
import {
  Link,
  useNavigate,
  useSearchParams,
  useLocation,
} from "react-router-dom";
import { apiConstant } from "../../../services/apiConfig";
import Layout from "../../../components/layout";
import { getApi, post } from "../../../services/apiService";
import { useAuth } from "../../../contexts/AuthContext";
import {
  commonStrings,
  signIn,
  validationMsg,
} from "../../../services/stringConstant";
import { MenuType } from "../../../types/menuType.types";

interface FormData {
  uname: string;
  pass: string;
}

const SignIn: React.FC = () => {
  const [formData, setFormData] = useState<FormData>({ uname: "", pass: "" });
  const [open, setOpen] = useState(false);
  const [number1] = useState(Math.floor(Math.random() * 10));
  const [number2] = useState(Math.floor(Math.random() * 10));
  const [userAnswer, setUserAnswer] = useState("");
  const [warn, setWarn] = useState("");
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const [isContactLink, setIsContactLink] = useState();
  const { login } = useAuth();
  const [footerList, setFooterList] = useState<MenuType[]>([]);
  const [contactPath, setContactPath] = useState("");
  const location = useLocation();
  const redirectUrl = localStorage.getItem("redirectUrl") ?? "";
  const [isRedirect, setIsRedirect] = useState(false);

  useEffect(() => {
    if (redirectUrl) {
      setIsRedirect(true);
    }
  }, [redirectUrl]);

  const onsubmitHandler = async (e: React.FormEvent) => {
    e.preventDefault();
    setOpen(true);
    const resultValue = checkCaptcha();

    if (!formData.uname) {
      setWarn(validationMsg.userNameRequired);
      setOpen(false);
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    } else if (!formData.pass) {
      setWarn(validationMsg.passwordRequired);
      setOpen(false);
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    if (resultValue === "true") {
      try {
        const response = await getApi(
          `${apiConstant.userChangePasswordPolicy}/${formData.uname}`
        );
        if (response.data === true) {
          navigate(
            { pathname: "/change-password", search: `?user=${formData.uname}` },
            { replace: true }
          );
        } else {
          const loginResponse = await post(
            `${apiConstant.userLogin}/${formData.uname}/${formData.pass}`,
            {}
          );
          if (loginResponse && loginResponse.userName) {
            localStorage.setItem("loginsession", JSON.stringify(loginResponse));
            localStorage.setItem("token", loginResponse.token);
            login();
            setOpen(false);
            setWarn("");
            localStorage.setItem("isFirstTime", "false");
            const redirectTo = searchParams.get("redirectTo");
            if (isRedirect) {
              navigate(redirectUrl, { replace: true });
              localStorage.removeItem("redirectUrl");
            } else if (location.state?.from?.pathname) {
              navigate(
                location.state?.from?.pathname + location.state?.from?.search,
                { replace: true }
              );
            } else {
              navigate(redirectTo ? `${redirectTo}` : "/", { replace: true });
            }
          } else {
            setWarn(validationMsg.userDeActive);
            setOpen(false);
            window.scrollTo({ top: 0, behavior: "smooth" });
          }
        }
      } catch (err) {
        setWarn(validationMsg.userNamePassword);
        setOpen(false);
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    } else {
      setWarn(commonStrings.CHATCHAERROR);
      setOpen(false);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const checkCaptcha = () => {
    const correctAnswer = number1 + number2;
    const parsedUserAnswer = parseInt(userAnswer, 10);

    return parsedUserAnswer === correctAnswer ? "true" : "false";
  };

  useEffect(() => {
    getApi(apiConstant.getFooterList)
      .then((res) => {
        setFooterList(res);
        // Find contact path from footer data
        const tiolInfo = res.find(
          (item: MenuType) => item.title === commonStrings.TIOL_INFO
        );
        if (tiolInfo) {
          const contactItem = tiolInfo.subMenuItems.find((item: MenuType) =>
            item.title.toLowerCase().includes("contact")
          );
          if (contactItem) {
            setContactPath(contactItem.webpath);
          }
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }, []);

  useEffect(() => {
    if (warn !== "") {
      setTimeout(() => {
        setWarn("");
      }, 6000);
    }
  }, [warn]);

  return (
    <Layout>
      <div className="container mt-10 mx-auto md:w-1/4">
        {warn && (
          <div className="bg-red-50 border-l-4 border-red-500 text-red-700 p-4 rounded mb-4 shadow-sm">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <svg
                  className="h-5 w-5 text-red-500"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <div className="ml-3">
                <p className="text-sm">{warn}</p>
                {warn.includes("contact TIOL") && contactPath && (
                  <p className="text-sm mt-1">
                    <Link
                      to={`/${contactPath}`}
                      className="text-red-700 underline hover:text-red-800"
                      state={{
                        apiUrl: footerList
                          .find(
                            (item: MenuType) =>
                              item.title === commonStrings.TIOL_INFO
                          )
                          ?.subMenuItems.find((item: { title: string }) =>
                            item.title.toLowerCase().includes("contact")
                          )?.apipath,
                      }}
                    >
                      Contact Support
                    </Link>
                  </p>
                )}
              </div>
            </div>
          </div>
        )}
        {open && (
          <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center">
            <div className="flex items-center">
              <div className="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-12 w-12"></div>
            </div>
          </div>
        )}
        <form
          onSubmit={onsubmitHandler}
          className="max-w-md mx-auto p-6 bg-white shadow-md rounded-md space-y-6 my-6 border"
        >
          <div className="text-3xl font-bold text-center text-gray-800 mb-6 ">
            {commonStrings.SIGNIN}
          </div>
          <div className="flex flex-col space-y-4">
            <div className="flex flex-col space-y-2">
              <label
                htmlFor="uname"
                className="text-sm font-medium text-gray-700 required-label"
              >
                {signIn.userName}{" "}
              </label>
              <input
                id="uname"
                name="uname"
                type="text"
                value={formData.uname}
                required
                onChange={(e) =>
                  setFormData({ ...formData, uname: e.target.value })
                }
                className="border border-gray-300 p-3 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter your username"
              />
            </div>
            <div className="flex flex-col space-y-2">
              <label
                htmlFor="pass"
                className="text-sm font-medium text-gray-700 required-label"
              >
                {signIn.password}
              </label>
              <input
                id="pass"
                name="pass"
                type="password"
                required
                value={formData.pass}
                onChange={(e) =>
                  setFormData({ ...formData, pass: e.target.value })
                }
                className="border border-gray-300 p-3 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter your password"
              />
            </div>
            <div className="flex flex-col space-y-2">
              <label className="text-sm font-medium text-gray-700 required-label">
                {commonStrings.Captcha}
              </label>
              <div className="flex items-center space-x-2">
                <div className="text-lg font-semibold text-green-600">
                  {number1} + {number2} =
                </div>
                <input
                  type="text"
                  required
                  value={userAnswer}
                  onChange={(e) => setUserAnswer(e.target.value)}
                  className="border border-gray-300 p-3 rounded-md flex-grow focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Enter captcha answer"
                />
              </div>
            </div>
          </div>
          <button
            type="submit"
            className="w-full bg-orange-main text-white py-3 rounded-md font-semibold hover:bg-orange-600 transition duration-200"
          >
            Login
          </button>
          <div className="flex justify-between items-center text-sm text-gray-600 mt-4">
            <button
              type="button"
              onClick={() => navigate("/sign-up", { replace: true })}
              className="text-orange-500 hover:underline flex items-center"
            >
              {/* <HowToRegIcon className="mr-1" />  */}
              {commonStrings.REGISTER}
            </button>
            <button
              type="button"
              onClick={() => navigate("/forgot-password", { replace: true })}
              className="text-orange-500 hover:underline"
            >
              {commonStrings.FORGOT_PASSWORD}
            </button>
          </div>
        </form>
      </div>
    </Layout>
  );
};
export default SignIn;
